import { ReactNode, useMemo } from 'react';
import FormGroupFrame from '../../../FormGroupFrame/FormGroupFrame';
import { JSONObject } from '../../../../../types/types';
import { useFormInitRegistration } from '../../hooks/useFormInitRegistration';
import { useFormItemVisibility } from '../../hooks/useFormItemVisibility';
import { FormVisibilityNode } from '../../utils/getInitialFormItemVisibility';

interface FormGroupProps {
  caption?: string;
  className?: string;
  visible?: boolean | string;
  allowVisible?: boolean;
  items: FormVisibilityNode[];
  resolveData: JSONObject;
  children: ReactNode;
}

const FormGroup = ({
  caption,
  className,
  visible,
  allowVisible,
  items,
  resolveData,
  children,
}: FormGroupProps) => {
  const visibilityNode = useMemo<FormVisibilityNode>(
    () => ({ visible, allowVisible, items }),
    [allowVisible, items, visible]
  );
  const { visible: resolvedVisibility, pending } = useFormItemVisibility(
    visibilityNode,
    resolveData
  );
  useFormInitRegistration(pending);

  if (!resolvedVisibility) {
    return null;
  }

  return (
    <FormGroupFrame caption={caption} className={className}>
      {children}
    </FormGroupFrame>
  );
};

export default FormGroup;
